
import {Exception} from '@/api/interfaces';

export default ({
  props: ['mode'],
  data: () => ({
    exceptions: [] as Exception[],
  }),
});
